import React from 'react';
import ReactDOM from 'react-dom';
import { MdCloudUpload } from 'react-icons/md';
import { Backdrop, IconWrapper, DropText, DropSubText } from './DragOverlay.styled';

interface DragOverlayProps {
  visible: boolean;
  text?: string;
  subText?: string;
}

const DragOverlay: React.FC<DragOverlayProps> = ({
  visible,
  text = 'Drop files to attach',
  subText = 'Release to add them to your message',
}) => {
  if (!visible) return null;

  return ReactDOM.createPortal(
    <Backdrop>
      <IconWrapper>
        <MdCloudUpload size={64} />
      </IconWrapper>
      <DropText>{text}</DropText>
      <DropSubText>{subText}</DropSubText>
    </Backdrop>,
    document.body,
  );
};

export default DragOverlay;
